<template>
    <div class="copyrightNotice-div col-xxl-12 col-xl-12 col-lg-12 col-md-12">
        <div class="copyrightNotice-content-div col-xxl-8 col-xl-10 col-lg-10 col-md-10">
            <div class="ContactUs-div d-none d-lg-block" ref="header" :class="{ 'move-div-left': header_Animate }">
                <div class="ContactUs-title-div banCopy">
                    <h5 class="ContactUs-title-textCH">联系我们</h5>
                    <h9 class="ContactUs-title-textEn">Contact Us</h9>
                </div>
                <div class="ContactUs-content-div col-xxl-7 col-xl-7 col-lg-7">
                    <ul class="list-unstyled">
                        <li>
                            <span class="banCopy">地址：</span>
                            <span>杭州市余杭区联创街193号杭开合创源</span>
                        </li>
                        <li>
                            <span class="banCopy">电话（传真）：</span>
                            <span>0571-28113202</span>
                        </li>
                        <li>
                            <span class="banCopy">邮箱：</span>
                            <span>hkjt@hkjt.cn</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="link-div col-xxl-4 col-xl-5 col-lg-5 banCopy transition" ref="header"
                :class="{ 'move-div-right': header_Animate }">
                <p class="col-11">
                    <a  class="link-item hand" @click="gotoPage($event)">官网首页</a>
                    <a  class="link-item hand link-item-border" @click="gotoPage($event)">集团概况</a>
                    <a  class="link-item hand link-item-border" @click="gotoPage($event)">新闻动态</a>
                    <a  class="link-item hand" @click="gotoPage($event)">业务领域</a>
                </p>
                <p class="col-11">
                    <a  class="link-item hand" @click="gotoPage($event)">企业文化</a>
                    <a  class="link-item link-item-border hand" @click="gotoPage($event)">联系我们</a>
                    <a  class="link-item link-item-border hand" @click="gotoPage($event)">人员招聘</a>
                    <a href="https://exmail.qq.com/login" class="link-item" target="_blank">邮箱登录</a>
                </p>
            </div>
        </div>

        <div class="copyrightNotice-title-div banCopy">
            <span class="copyrightNotice-title-item">杭开控股集团有限公司</span>
            <span class="copyrightNotice-title-item">CopyRight©HaiKaiGroup 1958-2021</span>
            <span class="copyrightNotice-title-item">ICP备案号：浙ICP备20014162号-1</span>
        </div>
    </div>
</template>

<script>
import { isElementNotInViewport } from "../js/utils.js";
export default {
    data() {
        return {
            header_Animate: false,
        }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener("scroll", this.scrollToTop);
    },
    beforeRouteLeave(to, form, next) {
        // 离开路由移除滚动事件
        window.removeEventListener('scroll', this.scrollToTop, true);
        next();
    },
    methods: {
        // 滚动事件
        scrollToTop() {
            !isElementNotInViewport(this.$refs.header) ? this.header_Animate = true : '';
            if (screen.width < 991) {
                this.header_Animate = false;
            } else {
                !isElementNotInViewport(this.$refs.header) ? this.header_Animate = true : '';
            }
        },
        gotoPage(e) {
            var string = e.currentTarget.innerHTML;
            switch (string) {
                case "官网首页":
                    this.$router.push({ name: 'home' });
                    break;
                case "集团概况":
                    this.$router.push({ name: 'overview' });
                    break;
                case "新闻动态":
                    this.$router.push({ name: 'newsList' });
                    break;
                case "业务领域":
                    this.$router.push({ name: 'areas' });
                    break;
                case "企业文化":
                    this.$router.push('/corporateCulture/culture');
                    break;
                case "联系我们":
                    this.$router.push({ name: 'contactUs' });
                    break;
                case "人员招聘":
                    this.$router.push({ name: 'recruit' });
                    break;
            }
        }
    }
}

</script>

<style scoped>
.ContactUs-title-textCH{
    color: rgb(54, 54, 54);
}

.ContactUs-content-div>ul>li>span{
    font-size: 0.9375rem;
}

.ContactUs-title-textEn{
    font-size: 0.9375rem;
}

@keyframes move-left {
    0% {
        transform: translateX(-500px);
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes move-right {
    0% {
        transform: translateX(+1000px);
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}


.move-div-left {
    animation: move-left 3s;
}

.move-div-right {
    animation: move-right 3s;
}


.copyrightNotice-title-div {
    border-top: 1px solid #989898;
    text-align: center;
    font-size: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.copyrightNotice-title-item {
    font-size: 0.75rem;
    padding-left: 4rem;
}

.copyrightNotice-div {
    background-color: #f6f6f6;
    height: 22.5rem;
    color: #989898;
    letter-spacing: 0.12rem;
}

.copyrightNotice-content-div {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    height: 85%;
    align-items: center;
    text-align: justify;
    margin: 0 auto;
}

.copyrightNotice-content-div>div {
    display: flex;
    align-items: center;
}

h5 {
    color: #363636d5;
    display: block;
    width: 6.42rem;
    letter-spacing: 0.355rem;
    white-space: nowrap;
}

.ContactUs-title-div {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: fit-content;
    float: left;
    height: 6.9rem;
}

.ContactUs-content-div {
    font-size: 1rem;
    height: 7.625rem;
    white-space: nowrap;
}

.ContactUs-div {
    display: flex;
    flex-direction: row;
    width: fit-content;
}

.ContactUs-div>div {
    padding-right: 3rem;
    height: 6.9rem;
    display: flex;
    align-items: center;
}

.list-unstyled {
    line-height: 2.2rem;
}


.link-div {
    display: flex;
    flex-wrap: wrap;
    height: 7.625rem;
    white-space: nowrap;
}

.link-item {
    padding: 0 1rem 0 0.5rem;
    color: #989898;
    text-decoration: none;
    font-size: 0.9375rem;
}

.link-item:hover {
    color: #237fef;
    text-decoration: underline;
}

@media screen and (max-width:1296px) {
    .link-item {
        padding: 0 1rem 0 0.5rem;
        transition-duration: 0.8s;
    }
}

@media screen and (max-width: 991px) {
    p {
        text-align: center;
        transition-duration: 0.8s;
    }

    .link-item-border {
        border-left: 1px solid #989899;
        border-right: 1px solid #989899;
        margin-right: -1px;
        transition-duration: 0.8s;
    }

    .link-div {
        display: flex;
        justify-content: center;
        transition-duration: 0.8s;
    }

    .link-item {
        padding: 0 1rem 0 1rem;
        transition-duration: 0.8s;
    }

    .copyrightNotice-content-div {
        height: 64%;
        transition-duration: 0.8s;
    }

    .copyrightNotice-title-item {
        display: flex;
        flex-direction: column;
        padding-left: 0;
        transition-duration: 0.8s;
    }

    .copyrightNotice-div {
        height: 15rem;
        transition-duration: 0.8s;
    }
}


@media screen and (max-width:576px) {
    .link-item {
        padding: 0 0.3rem 0 0.3rem;
        transition-duration: 0.8s;
    }
}
</style>